import React, { FC } from 'react';
import { StyledLine } from '../ContactInformation.styles';

export interface ContentProps {
  lines: string[];
}

const Content: FC<ContentProps> = ({ lines }) => (
  lines ? <>{lines.map((l) => <StyledLine key={l}>{l}</StyledLine>)}</> : null
);

export default Content;
